import './Filter.scss';
import filterAttibutes from 'data/framework-filters.json';

import React from 'react';

import * as Core from 'components/core';

import { FrameworkFilters } from './useFrameworkFilters';
import classNames from 'classnames';

interface Props {
  index: number;
  filters: FrameworkFilters;
}

const Filter: React.FC<Props> = (props) => {
  const { index, filters } = props;

  const filter = filters.filters[index] || { attribute: null, value: null };

  const selectedAttribute =
    filter.attribute && filterAttibutes.find((a) => a.id === filter.attribute);

  return (
    <div
      className={classNames('FrameworkFilter', {
        'is-new': !selectedAttribute
      })}
    >
      <div className="FrameworkFilter-attributeSelect">
        <Core.Select
          value={filter.attribute}
          onChange={(event) =>
            filters.setAttribute(index, event.currentTarget.value)
          }
          placeholder="Select Filter"
        >
          {filterAttibutes.map((attribute) => (
            <option key={attribute.id} value={attribute.id}>
              {attribute.name}
            </option>
          ))}
        </Core.Select>
      </div>

      <div className="FrameworkFilter-separator">&rarr;</div>

      <div className="FrameworkFilter-valueSelect">
        <Core.Select
          value={filter.value}
          onChange={(event) =>
            filters.setValue(index, event.currentTarget.value)
          }
          placeholder="Select Filter"
        >
          {selectedAttribute &&
            selectedAttribute.attributes.map((attribute) => (
              <option key={attribute} value={attribute}>
                {attribute}
              </option>
            ))}
        </Core.Select>
      </div>

      <button
        className="FrameworkFilter-clear"
        onClick={() => filters.remove(index)}
      >
        Remove ×
      </button>
    </div>
  );
};

export default Filter;
